import { render, staticRenderFns } from "./ExpoWarehouseLink.vue?vue&type=template&id=60e2e33c&scoped=true"
import script from "./ExpoWarehouseLink.vue?vue&type=script&lang=js"
export * from "./ExpoWarehouseLink.vue?vue&type=script&lang=js"
import style0 from "./ExpoWarehouseLink.vue?vue&type=style&index=0&id=60e2e33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e2e33c",
  null
  
)

export default component.exports